/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './user-vaccination-schedule-details.reducer';

export const UserVaccinationScheduleDetails = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const userVaccinationScheduleDetailsList = useAppSelector(state => state.userVaccinationScheduleDetails.entities);
  const loading = useAppSelector(state => state.userVaccinationScheduleDetails.loading);
  const totalItems = useAppSelector(state => state.userVaccinationScheduleDetails.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="user-vaccination-schedule-details-heading" data-cy="UserVaccinationScheduleDetailsHeading">
        <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.home.title">User Vaccination Schedule Details</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/user-vaccination-schedule-details/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.home.createLabel">
              Create new User Vaccination Schedule Details
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.userVaccinationScheduleDetails.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {userVaccinationScheduleDetailsList && userVaccinationScheduleDetailsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('dosage')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.dosage">Dosage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dosage')} />
                </th>
                <th className="hand" onClick={sort('givenDate')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.givenDate">Given Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('givenDate')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedDt')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.lastModifiedDt">Last Modified Dt</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedDt')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('periodInDays')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.periodInDays">Period In Days</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('periodInDays')} />
                </th>
                <th className="hand" onClick={sort('recDateMax')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.recDateMax">Rec Date Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recDateMax')} />
                </th>
                <th className="hand" onClick={sort('recDateMin')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.recDateMin">Rec Date Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recDateMin')} />
                </th>
                <th className="hand" onClick={sort('risk')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.risk">Risk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('risk')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('vaccinationTypeCd')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.vaccinationTypeCd">Vaccination Type Cd</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vaccinationTypeCd')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('completionStatus')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.completionStatus">Completion Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('completionStatus')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('batchNumber')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.batchNumber">Batch Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('batchNumber')} />
                </th>
                <th className="hand" onClick={sort('serialNumber')}>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.serialNumber">Serial Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serialNumber')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.glucoUser">Gluco User</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.vaccination">Vaccination</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.scheduleDetails">Schedule Details</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {userVaccinationScheduleDetailsList.map((userVaccinationScheduleDetails, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/user-vaccination-schedule-details/${userVaccinationScheduleDetails.id}`}
                      color="link"
                      size="sm"
                    >
                      {userVaccinationScheduleDetails.id}
                    </Button>
                  </td>
                  <td>{userVaccinationScheduleDetails.active ? 'true' : 'false'}</td>
                  <td>{userVaccinationScheduleDetails.dosage}</td>
                  <td>{userVaccinationScheduleDetails.givenDate}</td>
                  <td>
                    {userVaccinationScheduleDetails.lastModifiedDt ? (
                      <TextFormat type="date" value={userVaccinationScheduleDetails.lastModifiedDt} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{userVaccinationScheduleDetails.microSec}</td>
                  <td>{userVaccinationScheduleDetails.periodInDays}</td>
                  <td>{userVaccinationScheduleDetails.recDateMax}</td>
                  <td>{userVaccinationScheduleDetails.recDateMin}</td>
                  <td>{userVaccinationScheduleDetails.risk}</td>
                  <td>{userVaccinationScheduleDetails.timestampentry}</td>
                  <td>{userVaccinationScheduleDetails.vaccinationTypeCd}</td>
                  <td>{userVaccinationScheduleDetails.lastupdated}</td>
                  <td>{userVaccinationScheduleDetails.completionStatus}</td>
                  <td>{userVaccinationScheduleDetails.cursor}</td>
                  <td>{userVaccinationScheduleDetails.batchNumber}</td>
                  <td>{userVaccinationScheduleDetails.serialNumber}</td>
                  <td>
                    {userVaccinationScheduleDetails.glucoUser ? (
                      <Link to={`/gluco-user/${userVaccinationScheduleDetails.glucoUser.id}`}>
                        {userVaccinationScheduleDetails.glucoUser.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {userVaccinationScheduleDetails.vaccination ? (
                      <Link to={`/vaccination/${userVaccinationScheduleDetails.vaccination.id}`}>
                        {userVaccinationScheduleDetails.vaccination.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {userVaccinationScheduleDetails.scheduleDetails ? (
                      <Link to={`/vaccination-schedule-details/${userVaccinationScheduleDetails.scheduleDetails.id}`}>
                        {userVaccinationScheduleDetails.scheduleDetails.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/user-vaccination-schedule-details/${userVaccinationScheduleDetails.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/user-vaccination-schedule-details/${userVaccinationScheduleDetails.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/user-vaccination-schedule-details/${userVaccinationScheduleDetails.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.home.notFound">
                No User Vaccination Schedule Details found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={userVaccinationScheduleDetailsList && userVaccinationScheduleDetailsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default UserVaccinationScheduleDetails;
